<template>
    <div class="profile-page">
        <!-- 头像区域 -->
        <div class="avatar-section">
            <div class="avatar-wrapper">
                <img :src="userInfo.avatar" alt="avatar">
            </div>
        </div>

        <!-- 信息表单 -->
        <van-form class="info-form">
            <!-- 姓名 -->
            <van-field
                v-model="userInfo.name"
                label="姓名"
                :border="false"
                input-align="right"
                readonly
            />

            <!-- 身份证号 -->
            <van-field
                v-model="userInfo.idCard"
                label="身份证号"
                :border="false"
                input-align="right"
                readonly
            />

            <!-- 手机号 -->
            <van-field
                v-model="userInfo.phone"
                label="手机号"
                :border="false"
                input-align="right"
                readonly
            />
        </van-form>

        <!-- 其他信息 -->
        <div class="other-info">
            <!-- 工作状态 -->
            <van-field
                v-model="userInfo.workingState"
                label="工作状态"
                :border="false"
                input-align="right"
                readonly
            />

            <!-- 所属医院 -->
            <van-field
                v-model="userInfo.medicalName"
                label="所属医院"
                :border="false"
                input-align="right"
                readonly
            />
            
            <!-- 工作岗位 -->
            <van-field
                v-model="userInfo.work"
                label="工作岗位"
                :border="false"
                input-align="right"
                readonly
            />
        </div>

    </div>
</template>

<script>
import { getLoginInfo } from '@/api/index'
import { getToken, getUserInfoCache, setUserInfoCache } from '@/utils/auth'

const DEFAULT_AVATAR = 'https://img.yzcdn.cn/vant/cat.jpeg'

function mapToProfileUser(src) {
    if (!src || (!src.id && !src.account)) return null
    return {
        id: src.id || '',
        name: src.name || '',
        account: src.account || '',
        avatar: src.avatar || DEFAULT_AVATAR,
        idCard: src.idCard || '',
        phone: src.phone || '',
        medicalName: src.medicalName || src.hospital || '',
        workingState: src.workingState || src.type || '',
        work: src.work || ''
    }
}

export default {
    name: 'Profile',
    data() {
        return {
            userInfo: {
                id: '',
                name: '',
                account: '',
                avatar: DEFAULT_AVATAR,
                idCard: '',
                phone: '',
                medicalName: '',
                workingState: '',
                work: ''
            }
        };
    },
    created() {
        const storeUserInfo = this.$store.state.userInfo || {}
        const cacheUserInfo = getUserInfoCache() || {}
        const local = mapToProfileUser(storeUserInfo) || mapToProfileUser(cacheUserInfo)
        if (local) {
            this.userInfo = local
        }
        this.fetchUserInfo()
    },
    methods: {
        fetchUserInfo() {
            if (!getToken()) {
                return
            }
            getLoginInfo()
                .then(res => {
                    if (!res.data) return
                    const userInfo = {
                        id: res.data.id || '',
                        name: res.data.name || '',
                        account: res.data.account || '',
                        avatar: res.data.avatar || DEFAULT_AVATAR,
                        idCard: res.data.idCard || '',
                        phone: res.data.phone || '',
                        medicalName: res.data.medicalName || res.data.hospital || '',
                        workingState: res.data.workingState || res.data.type || '',
                        work: res.data.work || ''
                    }
                    this.userInfo = userInfo
                    setUserInfoCache(userInfo)
                    this.$store.commit('setUserInfo', userInfo)
                })
                .catch(err => {
                    console.error('获取用户信息失败:', err)
                })
        }
    }
};
</script>

<style scoped lang='scss'>
.profile-page {
    min-height: 100vh;
    background: #f5f5f5;
}

.avatar-section {
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    padding: 40px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.avatar-wrapper {
    position: relative;
    width: 80px;
    height: 80px;
}

.avatar-wrapper img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(255, 255, 255, 0.8);
}


.info-form {
    background: #fff;
    margin: 15px;
    border-radius: 12px;
    overflow: hidden;
    
    ::v-deep .van-cell {
        padding: 16px 15px;
        
        &::after {
            border-bottom: 1px solid #f5f5f5;
        }
        
        &:last-child::after {
            border-bottom: none;
        }
    }
    
    ::v-deep .van-field__label {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        width: 80px;
    }
    
    ::v-deep .van-field__value {
        font-size: 15px;
    }
    
    ::v-deep .van-field__control {
        color: #333;
        
        &::placeholder {
            color: #c8c9cc;
        }
    }
}

.other-info {
    background: #fff;
    margin: 15px;
    border-radius: 12px;
    overflow: hidden;
    
    ::v-deep .van-cell {
        padding: 16px 15px;
        
        &::after {
            border-bottom: 1px solid #f5f5f5;
        }
        
        &:last-child::after {
            border-bottom: none;
        }
    }
    
    ::v-deep .van-field__label {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        width: 80px;
    }
    
    ::v-deep .van-field__value {
        font-size: 15px;
    }
    
    ::v-deep .van-field__control {
        color: #333;
        
        &::placeholder {
            color: #c8c9cc;
        }
    }
    
}
</style>

